<div class="confirm-dialog">
  <h1 mat-dialog-title>
    {{ "COMPONENTS.LOGOUT_CONFIRM_DIALOG.TITLE" | translate }}
  </h1>
  <div mat-dialog-content>
    {{ "COMPONENTS.LOGOUT_CONFIRM_DIALOG.CONFIRM" | translate }}
    <br/><br/>
    <div>
      <div>{{ currentUser.first_name }} {{ currentUser.last_name }} ({{ currentUser.username }})</div>
      <div>{{ currentUser.email }}</div>
    </div>
  </div>
  <div mat-dialog-actions>
    <button mat-button mat-raised-button color="primary" (click)="logout($event)">
      <mat-icon>logout</mat-icon>
      {{ "COMPONENTS.LOGOUT_CONFIRM_DIALOG.LOGOUT" | translate }}
    </button>
    <button
      mat-button
      mat-raised-button
      mat-dialog-close
      (click)="cancel($event)"
    >
      {{ "COMMON.CANCEL" | translate }}
    </button>
  </div>
</div>


